import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { QuestionnaireEdit } from "@/features/catalog";
import { questionnaireDefinitionRouteId } from "@/features/catalog/lib/questionnaire-definition-route";

export const Route = createFileRoute("/catalog/performance-measures/new")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canWrite("Questionnaire")) {
      throw redirect({ to: "/catalog/performance-measures" });
    }
  },
  component: NewQuestionnaireComponent,
});

function NewQuestionnaireComponent() {
  const navigate = useNavigate();
  const backToQuestionnaires = () => navigate({ to: "/catalog/performance-measures" });
  const toCreated = (url?: string) =>
    url
      ? navigate({
          to: "/catalog/performance-measures/$questionnaireId",
          params: { questionnaireId: questionnaireDefinitionRouteId(url) },
        })
      : backToQuestionnaires();

  return <QuestionnaireEdit performance canEdit onDone={toCreated} onCancel={backToQuestionnaires} />;
}
